<template>
  <div class="p-box">
    <div class="con-search">
      <van-field v-model="teamName" placeholder="搜索产品名称" />
      <div @click="onsearch" class="s-icon"></div>
    </div>
    <div class="team-peo-box">
      <div class="team-peo-nav">
        <div
          v-for="(item,index) in pickerList"
          :key="index"
          @click="checkNav(item,index)"
          class="team-peo-font"
        >
          <div>{{item.name}}</div>
          <svg-icon :icon-class="isCheck==item.name?'team_icon1':'team_icon0'"></svg-icon>
        </div>
      </div>
      <div class="team-peo-data" v-for="(item,index) in dataList" :key="index">
        <dir class="data-list data-list-top">
          <div class="data-list-top-img">
            <img class="user-img" :src="item.avatarName ? item.avatarName : headerImg" alt />
          </div>
        </dir>
        <div class="data-list-bot">
          <div class="list-top-r">
            <div class="user-name">{{item.username?item.username:item.nickName}}</div>
            <img src="@/assets/publicImg/vip.png" alt />
            <van-tag v-if="item.type==0" color="#FFA800">直系</van-tag>
            <van-tag v-if="item.type==1" color="#FDA829" plain>非直系</van-tag>
          </div>
            <div class="user-clients">
              <div>进件产品：<span class="user-num">{{item.productName}}</span></div>
              <div>订单号： {{item.orderId}} </div>
            </div>
          <div class="user-timer">进件时间：{{item.createTime}}</div>
        </div>
      </div>
      <div class="hint-div" v-if="isShow">暂无数据~~~</div>
    </div>
    <van-popup v-model="isBusiness" position="bottom" closeable>
      <div class="default-sort">
        <div>业务类型</div>
        <div class="sort-title">
          <div
            :class="business==item.type?'sort-sty sort-link-sty':'sort-sty'"
            v-for="(item,index) in businessColumns"
            :key="index"
            @click="onbusiness(item,index)"
          >{{item.title}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import URL from "@/api/api";
export default {
  data() {
    return {
      teamName: '',
      isCheck: '默认排序',
      sort: '',//排序分类 下拉
      pickerList: [
        { name: '业务类型', icon: 'team_icon0', icon1: 'team_icon1' },
      ],
      dataList: [],
      business: '',//已做业务分类
      isBusiness: false,//已做业务
      businessColumns: [
        { type: '', title: '全部' },
        { type: 'loan', title: '贷款' },
        { type: 'insurance', title: '保险' },
      ],
      hasOrder: '',//更多筛选分类
      headerImg: require('./img/team-img.png'),
      isShow:false//dataList是否有数据
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onsearch() {//搜索
      this.dataList=[]
      this.getData()
    },
    checkNav(n, i) {
      this.isCheck = n.name
      if (n.name == '业务类型') {
        this.isBusiness = true
      } 
    },
    getData() {
      let data = {
        userId: localStorage.getItem('userid'),
        productName:this.teamName,
        itemType:this.business,
      }
      this.$fetchGet(URL.teamOrders.url, data).then(res => {
        if(res.data.code==20000){
          this.dataList=res.data.data
          if(this.dataList?.length==0){
            this.isShow=true
          }
        }else{
          Toast(res.data.msg)
        }
      })
    },
    onbusiness(v, i) {
      this.business = v.type
      this.getData()
      this.isBusiness = false
    },
  }
}
</script>

<style lang="less" scoped>
.p-box {
  font-family: Source Han Sans CN;
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg1.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
    }
  }
  .team-peo-box {
    padding-bottom: 30px;
    .team-peo-nav,
    .team-peo-font {
      display: flex;
      align-items: center;
      font-size: 13px;
      font-weight: Regular;
      color: #333333;
    }
    .team-peo-nav {
      margin-top: 23.5px;
    }
    .team-peo-font {
      &:not(:first-child){
        margin-left: 35px;
      }
      .svg-icon {
        width: 8px;
        height: 8px;
        margin-left: 5px;
      }
    }
    .team-peo-data {
      width: 355px;
      height: 100px;
      margin-top: 15px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      .data-list {
        display: flex;
        align-items: center;
      }
      .data-list-top {
        width: 61px;
        margin-top: 12px;
        .data-list-top-img {
          display: flex;
          margin: auto;
          .user-img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
      }
      .data-list-bot {
        margin-top: 15px;
        font-weight: 400;
        font-size: 11px;
        color: #333333;
        .list-top-r {
          display: flex;
          img {
            width: 62px;
            height: 15px;
            display: block;
            margin-left: 5px;
          }
          .van-tag {
            margin-left: 11px;
          }
          .user-name {
            max-width: 75px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
            font-weight: 500;
          }
        }
        .user-clients{
          margin: 10px 0;
          display: flex;
          div{
            &:last-child{
              margin-left: 15px;
            }
          }
        }
      }
    }
    .hint-div{
      margin-top: 20px;
      text-align: center;
      font-size: 12px;
      color: #999;
    }
  }
  .van-popup {
    width: 375px;
    height: 339.5px;
    .default-sort {
      // // margin-top: 38px;
      // margin-left: 20px;
      padding: 38px 20px 0 20px;
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      .sort-title {
        margin-top: 71px;
        text-align: center;
      }
      .sort-sty {
        font-size: 13px;
        font-weight: Regular;
        color: #999999;
      }
      .sort-sty:not(:first-child) {
        margin-top: 22.5px;
      }
      .sort-link-sty {
        color: #fc6e09;
      }
    }
    /deep/.van-popup__close-icon--top-right {
      top: 38px;
      right: 20px;
    }
    .has-order-tit {
      margin-top: 24px;
      font-size: 13px;
      font-weight: Regular;
      color: #333333;
    }
    .has-order {
      display: flex;
      .more-sty {
        width: 50.5px;
        height: 21px;
        margin: 28px 15px 0 0;
        line-height: 21px;
        text-align: center;
        background: #fbfbfb;
        border-radius: 13.5px;
        font-size: 10.5px;
        color: #333333;
      }
      .more-link-sty {
        color: #fc6e09;
      }
    }
  }
}
</style>